import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsCustomFieldsRoute: InvariantJiraRoute = {
	name: 'plan-settings-custom-fields',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields',
};
